import { h, Component} from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import {Form, I18n, Button, FormEntry, Col, Row, Divider, Container, Toggle} from 'components/elements' 
import {connect} from 'react-redux'
import {PatientActions} from 'actions'
import style from './style.less'
import _ from 'lodash'

let mapInputType = {
	String: 'text',
	Dropdown: 'text',
	Integer: 'number',
	Float: 'number'
}

@Form
@connect((state)=>({
	...state
}))
export default class GenericPatientInformation extends WidgetComponent {
	constructor(props){
		super(props)
		this.state = {
            editing: false,
            error: '',
			age: {},
			customBooleans: {}
		}

		this.handleSubmit = this.handleSubmit.bind(this)
		this.handleToggleEdit = this.handleToggleEdit.bind(this)
		this.handlePatientUpdate = this.handlePatientUpdate.bind(this)
	}

	componentWillMount(){
		if(this.props.editing){
			this.setState({
				editing: this.props.editing
			})
		}	

		let customBooleans = {}
		for(let customField of this.customFields){
			if(customField.type == 'Boolean'){
				customBooleans[customField.key] = this.patient[customField.key] || false
			}
		}

		this.setState({
			customBooleans
		})
	}

	handleSubmit(values){
		if(this.componentIsLoading()){
			return
        }
        
        this.setState({
            error: ''
        })
		if(values.reason && Object.keys(values).length == 1){
			PatientActions.append({
				...this.patient,
				...values
			})
			this.componentWillSubmit().then((response)=>{
				this.handlePatientUpdate({
					...this.patient,
					...values
				})
			})
			return
		}

		let data = {
			...this.patient,
			...values,
			...this.state.customBooleans
		}

		PatientActions.append(data)
		if(this.newPatient){
			this.componentWillSubmit().then((response)=>{
				return PatientActions.create({...this.patient}).then((response)=>{
					if(this.state.editing){
						this.handleToggleEdit()
					}
					
					for(let key of Object.keys(this.props.FormData)){
						delete this.props.FormData[key]
					}
					super.componentDidSubmit()
					this.props.onSubmit && this.props.onSubmit(response.data)
				}).catch((e)=>{
					this.componentFailedToSubmit()
                    this.setState({
                        error: (e.response.data || {}).errors || ''
                    })
				})
			})
		} else {
			this.componentWillSubmit().then((response)=>{
				return PatientActions.update({
					...data,
					...this.patient
				}).then((response)=>{
					this.handlePatientUpdate({
						...response.data,
						...values
					})
				}).catch((e)=>{
                    this.componentFailedToSubmit()
                    this.setState({
                        error: (e.response.data || {}).errors || ''
                    })
                    console.log((e.response.data || {}).errors || '')
				})
			})
		}
	}

	handlePatientUpdate(data){
		if(this.state.editing){
			this.handleToggleEdit()
		}
		
		for(let key of Object.keys(this.props.FormData)){
			delete this.props.FormData[key]
		}

		super.componentDidSubmit()
		this.props.onSubmit && this.props.onSubmit(data)
	}

	get patient(){
		let patient = {
			...(this.props.patient || {})
		}
		return patient
	}

	get newPatient(){
		return /newPatient/.test(this.patient.id)
	}

	get organization(){
		return this.props.organization || {}
	}

	get customFields(){
		return Object.values(this.props.customFields || {}).filter((customField)=>{
			return customField.model == 'Patient'
		}).sort((a,b)=>{
			if(a.type == 'Boolean') return 1
			if(b.type == 'Boolean') return -1
			return 0
		})
	}

    get showReason(){
        let showReason = !(this.props.config.reason || {}).hide

        if(_.isNil(showReason)) showReason = true
        
        return showReason
    }

	handleToggleEdit(){
		this.setState({
			editing: !this.state.editing
		})
	}

	handleToggleCustomField(customField, e){
		this.setState({
			customBooleans: {
				...this.state.customBooleans,
				[customField.key]: !this.state.customBooleans[customField.key]
			}
		})
	}

	render(){
		const {Form, InputDark, SelectDark} = this.props
		let submitPrompt = this.state.editing?(
			<I18n>update</I18n>
		):this.newPatient?(
			<I18n>create</I18n>
		):(
			<I18n>next</I18n>
		)
		return (
			<Container>
				<Form for={this.patient.id || 'newPatient'} class={style.login} onSubmit={this.handleSubmit}>
					{!this.newPatient && 
						<div class={style.editText} onClick={this.handleToggleEdit}>
							{this.props.patient && this.state.editing ?
								<I18n>cancel</I18n>
							:
								<I18n>edit</I18n>
									}
						</div>
					}
					<div>
                        <strong>
                            Patient Information
                        </strong>
						<br />
						<br />
					</div>
					<Row>
                    {!this.newPatient && !this.state.editing?
							<Col span={{sm: 24, md: 12,lg: 8}}>
								<div>
									<label>
										<I18n>patientName</I18n>
									</label>
									<span>
										{this.patient.firstName} {this.patient.lastName}
									</span>
								</div>
							</Col>
						:
							[
								<Col span={{
									sm: 24,
									md: 12,
									lg: 8
								}}>
										<FormEntry>
											<label class={style.inputLabel}>
												<I18n>firstName</I18n>
											</label>
											<InputDark
												class={style.inputWithLabel}
												required={true}
												type='text'
												name='firstName'
												question={I18n.t("firstName")}
												initialValue={this.patient.firstName}
											/>
										</FormEntry>
								</Col>,
								<Col span={{
									sm: 24,
									md: 12,
									lg: 8
								}}>
									<FormEntry>
                                        <label class={style.inputLabel}>
                                            <I18n>lastName</I18n>
                                        </label>
                                        <InputDark
                                            class={style.inputWithLabel}
                                            required={true}
                                            type='text'
                                            name='lastName'
                                            question={I18n.t("lastName")}
                                            initialValue={this.patient.lastName}
                                        />
									</FormEntry>
								</Col>
							]
						}
						{this.customFields.map((customField)=>{
							if(!this.newPatient && !this.state.editing && !this.patient[customField.key] && !customField.required){
								return
							}
							return (
								<Col span={{sm: 24, md: 12, lg: 8}}>
									{!this.newPatient && !this.state.editing?
										<div>
											<label>
												{customField.label}
											</label>
											&nbsp;{!_.isNil(this.patient[customField.key]) ? `${this.patient[customField.key]}` : 'none'}
										</div>
									:
										<FormEntry >
											{customField.type == 'Boolean' &&
												<Toggle class={style.customToggle} selected={this.state.customBooleans[customField.key]} onSelect={this.handleToggleCustomField.bind(this, customField)}>
													{customField.label}
												</Toggle>
											}
											{customField.dropdownOptions && customField.dropdownOptions.length > 0 &&
												<SelectDark 
													required={customField.required} 
													name={customField.key}
													id={customField.key} 
													data={customField.dropdownOptions} 
													placeholder={customField.label} 
													initialValue={this.patient[customField.key]} 
												/>
											}	
											{(!customField.dropdownOptions || customField.dropdownOptions.length == 0) && customField.type != 'Boolean' &&
												<InputDark
													required={customField.required}
													type={mapInputType[customField.type]}
													step={customField.type == 'Float' && .01}
													name={customField.key}
													question={customField.label}
													initialValue={this.patient[customField.key]}
													onChange={this.handleColorChange} 
												/>
											}
										</FormEntry>
									}
								</Col>
							)
						})}
					</Row>
					<br />
					{!this.newPatient || this.state.editing &&
						<Divider />
					}
					{this.showReason && this.props.selectedTimeSlot.id && 
						<Row>
							<Col span={{sm: 24}}>
								{this.patient.reason && !this.state.editing?
									<div>
										<label>
											<I18n>reasonForVisit</I18n>
										</label>
										&nbsp;{this.patient.reason || 'none'}
									</div>
								:
									<FormEntry>
										<InputDark 
											required={true} 
											type='text' 
											name='reason' 
											id='reason' 
											question={I18n.t("reasonForVisit")}
											initialValue={this.patient.reason} />
									</FormEntry>
								}
							</Col>
						</Row>
					}
					<br />
					{this.state.error &&
						<div class={style.errorMessage}>{this.state.error}</div>	
					}
					{((this.props.selectedTimeSlot.id && !this.patient.reason) || this.newPatient || this.state.editing) && 
						<Button spinner={this.componentIsLoading()}>{submitPrompt}</Button>
					}
				</Form>
			</Container>
		);
	}
}



// WEBPACK FOOTER //
// ./components/partials/GenericPatientInformation/index.js